module.exports = __webpack_public_path__ + "img/register.6465585f.svg";